import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { RolesService } from '../../../core/services/roles.service';
import { Pagination } from '../../../core/dto/pagination';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-view-roles',
  templateUrl: './view-roles.component.html',
  styleUrls: ['./view-roles.component.scss'],
})
export class ViewRolesComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Users',
      icon: 'user',
      route: '/admin/users',
    },
    {
      title: 'Roles',
    },
  ];
  rolesData: any[] = [];

  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  isDeleting = false;

  skeletonTableColumns: any[] = [
    'Role Name',
    'Permissions',
    'Users',
    'Created Date',
    'Actions',
  ];
  loading = false;

  constructor(
    private rolesService: RolesService,
    private router: Router,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {}

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedRoles();
  }

  getPagedRoles(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
    });
    this.rolesService.getPagedRoles(payload).then((res: any) => {
      this.loading = false;
      this.rolesData = res[0].data;
      this.pageSize.length = res[0].metadata[0]?.total;
    });
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedRoles();
  }

  goto(id?: any): void {
    if (id) {
      this.router.navigate([`/admin/users/roles/add-edit/${id}`]);
    } else {
      this.router.navigate(['/admin/users/roles/add-edit']);
    }
  }

  confirm(id: any, isUserAssigned: boolean): void {
    this.isDeleting = true;
    if (isUserAssigned) {
      this.message.error(
        'Please try to delete after unassigned the role from the users.',
      );
      return;
    } else {
      this.rolesService?.deleteRole(id).then((res: any) => {
        this.message.success('Role has been deleted!');
        this.getPagedRoles();
        this.isDeleting = false;
      });
    }
  }

  beforeConfirm(): Observable<boolean> {
    return new Observable((observer) => {
      // this.rolesService?.deleteRole(this.deleteRoleId).then((res: any) => {
      //   const payload = Object.assign({}, new Pagination(this.pageSize),
      //     {sortField: this.sortField, sortOrder: this.sortOrder});
      //   this.getPagedRoles(payload);
      // })
    });
  }

  hasAccessToPerformAction(): boolean {
    return (
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'ROLE_UPDATE',
      ) ||
      _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), 'ROLE_DELETE')
    );
  }
  checkSuperAdmin(name: string) {
    return name === 'SUPER ADMIN';
  }
}
